import { use } from "react";
import type { UserType } from "./auth";
import { dateTimeFormat } from "./date";
import { InstanceContext } from "./instance";

export const UserCard = (props: { user: UserType }) => {
  return (
    <div className="card card-dash bg-base-100 w-96">
      <div className="card-body">
        <h2 className="card-title">
          {props.user.first_name} {props.user.last_name}
        </h2>
        <ul>
          <li>Username: {props.user.username}</li>
          <li>Created At: {dateTimeFormat(props.user.created_at)}</li>
          <li>Role: {props.user.role}</li>
        </ul>
        <div className="card-actions justify-end">
          <button type="button" className="btn btn-outline btn-warning">
            Deactivate
          </button>
          <button type="button" className="btn btn-outline btn-error">
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export const UserList = () => {
  const instance = use(InstanceContext);

  return (
    <div>
      <div className="divider divider-neutral" style={{ marginTop: "30px", marginBottom: "30px" }}>
        Users ({instance.users.length})
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-evenly" }}>
        {instance.users.map((user) => (
          <UserCard key={user.id} user={user} />
        ))}
      </div>
    </div>
  );
};
